module.exports = __webpack_public_path__ + "img/2_zero_hunger_color.cf93266e.svg";